// Reuse the header's configured game names, icons and destinations. These are
// ordinary collection links: clicking applies the game immediately, without a
// product scan or an extra Apply step, and still works without JavaScript.
export function gameDestination(value) {
  try {
    const url = new URL(value, location.origin);
    if (url.origin !== location.origin || !/\/(?:collections\/[^/]+(?:\/[^/]+)?|search)\/?$/.test(url.pathname)) return null;
    url.hash = '';
    return url;
  } catch { return null; }
}
export function gameIsActive(destination, current) {
  const target = gameDestination(destination), page = new URL(current, location.origin);
  if (!target || target.pathname.replace(/\/$/, '') !== page.pathname.replace(/\/$/, '')) return false;
  // Search-based game routes are identified by their query, not just /search.
  return !/\/search\/?$/.test(target.pathname) || target.searchParams.get('q') === page.searchParams.get('q');
}
function markCurrent(nav) {
  const links = [...nav.querySelectorAll('[data-bb-catalog-game]')];
  let selected = links.find(link => link.dataset.bbCatalogGame && gameIsActive(link.href, location.href));
  if (!selected) selected = links.find(link => !link.dataset.bbCatalogGame);
  links.forEach(link => {
    if (link === selected) link.setAttribute('aria-current', 'page');
    else link.removeAttribute('aria-current');
  });
}
export function setupCatalogGames() {
  const finder = document.querySelector('[data-bb-singles-menu] [data-bb-finder]');
  const select = finder?.querySelector('[data-bb-game-select]');
  document.querySelectorAll('[data-bb-catalog-games]').forEach(nav => {
    const list = nav.querySelector('ul');
    if (!list) return;
    if (select) {
      const configured = [], seen = new Set();
      finder.querySelectorAll('button[data-bb-game-label]').forEach(button => {
        const name = button.dataset.bbGameLabel;
        const option = [...select.options].find(item => item.textContent.trim() === name);
        const url = option?.value && gameDestination(option.value);
        if (!url || seen.has(url.href)) return;
        seen.add(url.href);
        const item = document.createElement('li'), link = document.createElement('a');
        link.className = 'bb-game-choice'; link.href = url.href; link.dataset.bbCatalogGame = name;
        button.childNodes.forEach(child => link.append(child.cloneNode(true)));
        item.append(link); configured.push(item);
      });
      if (configured.length) {
        const all = document.createElement('li'), link = document.createElement('a');
        link.className = 'bb-game-choice'; link.href = nav.dataset.allUrl; link.dataset.bbCatalogGame = ''; link.textContent = 'All games';
        all.append(link); list.replaceChildren(all, ...configured);
      }
    }
    markCurrent(nav);
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupCatalogGames);
else setupCatalogGames();
document.addEventListener('shopify:section:load', setupCatalogGames);
window.addEventListener('pageshow', setupCatalogGames);
window.addEventListener('popstate', () => document.querySelectorAll('[data-bb-catalog-games]').forEach(markCurrent));
